import _classCallCheck from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import ReactDOM from 'react-dom';
export default (function (superClass) {
  return /*#__PURE__*/function (_superClass) {
    _inherits(Rendered, _superClass);

    function Rendered() {
      _classCallCheck(this, Rendered);

      return _possibleConstructorReturn(this, _getPrototypeOf(Rendered).apply(this, arguments));
    }

    _createClass(Rendered, [{
      key: "_createRenderContainer",
      value: function _createRenderContainer() {
        return document.createElement('div');
      }
    }, {
      key: "render",
      value: function render() {
        this._renderContainer = this._renderContainer || this._createRenderContainer();
        var portal = ReactDOM.createPortal(this.props.children, this._renderContainer);
        this._children = [portal];
        return _get(_getPrototypeOf(Rendered.prototype), "render", this).call(this);
      }
    }, {
      key: "_configRef",
      value: function _configRef(element) {
        var _this = this;

        element.renderer = function (root) {
          _this._rendererRoot = root;

          _this._rendererRoot.appendChild(_this._renderContainer);
        };

        if (this._rendererRoot) {
          this._rendererRoot.appendChild(this._renderContainer);
        }
      }
    }]);

    return Rendered;
  }(superClass);
});